// extracted by mini-css-extract-plugin
module.exports = {"preview":"idt-sizeattributedropdownitem_preview__1kdcy"};